import { cn } from "@/lib/utils";
import { ComponentProps } from "react";

type Props = ComponentProps<"div">

export const CardGray = ({ className, ...props }: Props) => {
  return <div className={cn("bg-white border-gray-200 border rounded-xl p-6", className)} {...props} />
}
